/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, CardDescription, Input } from "@repo/ui";
import {
  Grid,
  GridColumn,
  getSelectedState,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { process, getter } from "@progress/kendo-data-query";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { MdUpdate } from "react-icons/md";
import { Loader2 } from "lucide-react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import {
  useGetIncidentDetails,
  useGetIncidentTicketDetails,
  useGetTasks,
} from "services/tickets";
import {
  useExportTicketsQuery,
  useGetAvailableColumns,
  useGetTicketsConfig,
  useGetTicketsQuery,
  useGetUserColumns,
  useGetUserSettings,
} from "services/dynamic-filtering";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import UpdateStatus from "../ticketDetails/update-status";
import { StatusContext } from "../constants";
import { fixKendoGridContent, getTicketDetailsPage } from "../utils";
import GridDataCopyCell from "components/copy";
import DynamicFiltering from "components/dynamicFiltering";
import eventBus from "store/event-emitter";
import ColumnActionsCell from "components/dynamicFiltering/column-actions";
import UpdateCallsStatus from "../callCenterAgentCalls/update-status";
import { getField } from "components/dynamicFiltering/utils";
import { useUser } from "hooks/use-user";
import { useGetPanicAlertIncidentTicketDetails } from "services/panic-alert";

export default function CCAAllTicketsListDF() {
  const user = useUser();
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    group: [],
  });

  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedState, setSelectedState] = useState({});
  const [userColumns, setUserColumns] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({
    filters: [],
    period: "all",
    searchString: "",
  });

  const isCCCalls = user?.Roles?.includes("CC Calls");
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const { setStatus } = useContext(StatusContext);
  const dataStateRef = useRef(dataState);
  const pageSize = 100;
  const _exporter = createRef();
  const DATA_ITEM_KEY = "ticketUniqueId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);
  const {
    mutate: getUserColumns,
    data: userColumnsRes,
    isPending: gettingUserColumns,
    reset: resetUserColumns,
  } = useGetUserColumns();

  const {
    mutate: getAvailableColumns,
    data: availableColumnsRes,
    isPending: gettingAvailableColumns,
  } = useGetAvailableColumns();

  const {
    mutate: getUserSettings,
    data: userSettingsRes,
    isPending: gettingUserSettings,
  } = useGetUserSettings();

  const {
    mutate: getTicketsConfig,
    data: ticketsConfig,
    isPending: gettingTicketsConfig,
  } = useGetTicketsConfig();

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetTicketsQuery();

  const {
    mutate: getTasks,
    data: tasksList,
    isPending: gettingTasks,
    reset: resetTaskList,
  } = useGetTasks();
  const {
    mutate: getPanicAlertDetails,
    data: panicAlertDetailsRes,
    isPending: gettingPanicAlertDetails,
    reset: resetPanicAlertDetails,
  } = useGetPanicAlertIncidentTicketDetails();
  const {
    mutate: getIncidentDetails,
    data: incidentDetailsRes,
    isPending: gettingIncidentDetails,
    reset: resetIncidentDetails,
  } = useGetIncidentTicketDetails();
  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportTicketsQuery();

  useEffect(() => {
    dataStateRef.current = dataState;
  }, [dataState]);
  useEffect(() => {
    const eventHandler = () => {
      onRefresh();
    };

    const updateColumnHandler = () => {
      getUserColumns("allcalls");
      getUserSettings("allcalls");
      getAvailableColumns("allcalls");
    };
    const actionEventHandler = (payload) => {
      if (payload?.type === "group") {
        const _group = {
          field: payload.field,
          operator: "eq",
          value: payload.value,
        };

        const _dataState = dataStateRef.current;
        const newGroups = [..._dataState.group];

        const existingGroupIndex = newGroups.findIndex(
          (elm) => elm.field === _group.field
        );
        if (existingGroupIndex !== -1) {
          newGroups[existingGroupIndex] = _group;
        } else {
          newGroups.push(_group);
        }
        setExpandedGroups({ [_group.field]: [_group.value] });
        setDataState({
          ..._dataState,
          group: newGroups,
        });
      }
    };
    updateColumnHandler();
    getUserSettings("allcalls");
    getTicketsConfig("allcalls");
    eventHandler();

    eventBus.on("updateFilters", eventHandler);
    eventBus.on("updateColumns", updateColumnHandler);
    eventBus.on("applyActions", actionEventHandler);

    return () => {
      eventBus.off("updateFilters", eventHandler);
      eventBus.on("updateColumns", updateColumnHandler);
      eventBus.off("applyActions", actionEventHandler);
    };
  }, []);

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
    if (userColumnsRes) {
      const sortedColumns = userColumnsRes.data.columns;
      sortedColumns.sort((a, b) => {
        if (a.order < b.order) {
          return true;
        }
        return false;
      });
      setUserColumns(sortedColumns);
      resetUserColumns();
    }
  }, [allTicketsData, userColumnsRes]);

  useEffect(() => {
    setCurrentPage(1);
    const data = {
      pageNumber: 1,
      pageRowCount: pageSize,
      ...filters,
    };
    if (isCCCalls) {
      data.filters.push({
        logic: "and",
        operator: "Equals",
        value: "false",
        field: "isServiceTicket",
      });
    }
    getTickets(data);
  }, [reload, filters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm, index) => ({
          ...elm,
          expanded: false,
          [SELECTED_FIELD]: false,
          region: elm.servicePointRegion || elm.region, //priority to servicePointRegion
          vaultAccessRequired: elm.vaultAccessRequired ? "Yes" : "No",
          vaultAccessAdded: elm.vaultAccessAdded ? "Yes" : "No",
          ticketUniqueId: `ticket-${elm.ticketId}-${index}`,
        }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    const data = {
      pageNumber: _page,
      pageRowCount: pageSize,
      ...filters,
    };
    if (isCCCalls) {
      data.filters.push({
        logic: "and",
        operator: "Equals",
        value: "false",
        field: "isServiceTicket",
      });
    }
    getTickets(data);
  };

  const onRefresh = () => {
    const data = {
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...filters,
    };
    if (isCCCalls) {
      data.filters.push({
        logic: "and",
        operator: "Equals",
        value: "false",
        field: "isServiceTicket",
      });
    }
    getTickets(data);
  };

  const updateCell = ({ dataItem }) => {
    return (
      <td>
        <div
          className="flex items-center justify-center w-full"
          title="Update Status"
        >
          {dataItem.isServiceTicket ? (
            <UpdateStatus
              triggerButton={
                <Button variant="outline">
                  <MdUpdate
                    fontSize="18px"
                    className="text-primary font-[18px]"
                  />
                </Button>
              }
              onReload={() => {
                setReload(!reload);
              }}
              requestDetails={dataItem}
            />
          ) : (
            <UpdateCallsStatus
              triggerButton={
                <Button variant="outline">
                  <MdUpdate
                    fontSize="18px"
                    className="text-primary font-[18px]"
                  />
                </Button>
              }
              onReload={() => {
                setReload(!reload);
              }}
              requestDetails={dataItem}
            />
          )}
        </div>
      </td>
    );
  };

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  const onExpandChange = (event) => {
    const { dataItem } = event;

    if (dataItem.field) {
      const _expandedGroups = { ...expandedGroups };
      const groupsKeys = Object.keys(expandedGroups);
      if (groupsKeys.find((elm) => elm === dataItem.field)) {
        groupsKeys.forEach((elm) => {
          if (elm === dataItem.field) {
            const currentList = expandedGroups[elm];
            const currentItemIndex = currentList.findIndex(
              (item) => item === dataItem.value
            );
            if (currentItemIndex !== -1) {
              _expandedGroups[elm].splice(currentItemIndex, 1);
              if (currentList.length === 0) {
                delete _expandedGroups[elm];
              }
            } else {
              _expandedGroups[elm].push(dataItem.value);
            }
          }
        });
      } else {
        _expandedGroups[dataItem.field] = [dataItem.value];
      }
      setExpandedGroups(_expandedGroups);
    } else {
      const _tickets = [...tickets];
      _tickets.forEach((elm, index) => {
        if (elm.ticketId === dataItem.ticketId) {
          _tickets[index].expanded = !elm.expanded;
        } else {
          elm.expanded = false;
        }
      });

      setTickets(_tickets);
      resetTaskList();
      resetIncidentDetails();
      resetPanicAlertDetails();
      if (dataItem.status !== "Draft") {
        if (dataItem.activityType === "Panic Alert Incident") {
          getPanicAlertDetails(dataItem.ticketId);
        }
        // if (
        //   dataItem.activityType === "Incident - Standard" ||
        //   dataItem.activityType === "Incident - Emergency"
        // ) {
        //   getIncidentDetails(dataItem.ticketId);
        // }
        else {
          getTasks(dataItem.ticketId);
        }
      }
    }
  };

  function DetailComponent() {
    if (gettingTasks || gettingIncidentDetails || gettingPanicAlertDetails) {
      return <Loader2 />;
    }

    if (incidentDetailsRes) {
      return (
        <div style={{ background: "white", padding: "12px" }}>
          <h1 className="text-md font-medium">Tasks List</h1>
          <Grid
            data={incidentDetailsRes?.data || []}
            style={{ margin: "20px 0", background: "white" }}
            className="detail-grid border-2"
          >
            <GridColumn
              title="Task Number"
              width="170px"
              filterable={false}
              field="taskNo"
              cell={(items) => {
                const dataItem = items.dataItem;

                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("allServiceAndNonService");
                          }}
                          to={getTicketDetailsPage(dataItem)}
                        >
                          {dataItem.taskNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />

            <GridColumn
              title="Assigned To"
              field="assigneeId"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />

            <GridColumn title="State" field="status" width="150px" />
            <GridColumn
              title="Resolution Code"
              field="resolutionCode"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />
            <GridColumn
              title="Resolution Details"
              field="resolutionDetails"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />
            <GridColumn
              title="Description"
              field="remarks"
              width={userSettingsRes?.data.wrapColumnText ? "400px" : "300px"}
              cell={GridDataCopyCell}
            />
          </Grid>
        </div>
      );
    } else if (panicAlertDetailsRes) {
      return (
        <div style={{ background: "white", padding: "12px" }}>
          <h1 className="text-md font-medium">Tasks List</h1>
          <Grid
            data={panicAlertDetailsRes?.data.tasks || []}
            style={{ margin: "20px 0", background: "white" }}
            className="detail-grid border-2"
          >
            <GridColumn
              title="Task Number"
              width="170px"
              filterable={false}
              field="taskNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("allServiceAndNonService");
                          }}
                          to={`${PATHS.panicAlertTaskDetails}/${dataItem.requestId}`}
                        >
                          {dataItem.taskNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />

            <GridColumn
              title="Assigned To"
              field="assigneeId"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />

            <GridColumn title="State" field="status" width="150px" />
            <GridColumn
              title="Resolution Code"
              field="resolutionCode"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
            />
            <GridColumn
              title="Resolution Details"
              field="resolutionDetails"
              width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
              cell={GridDataCopyCell}
            />
            <GridColumn
              title="Description"
              field="remarks"
              width={userSettingsRes?.data.wrapColumnText ? "400px" : "300px"}
              cell={GridDataCopyCell}
            />
          </Grid>
        </div>
      );
    }
    return (
      <div style={{ background: "white", padding: "12px" }}>
        <h1 className="text-md font-medium">Tasks List</h1>
        <Grid
          data={tasksList?.data || []}
          style={{ margin: "20px 0", background: "white" }}
          className="detail-grid border-2"
        >
          <GridColumn
            title="Task Number"
            width="170px"
            filterable={false}
            field="taskNo"
            cell={(items) => {
              const dataItem = items.dataItem;
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>
                      <Link
                        onClick={() => {
                          setStatus("allServiceAndNonService");
                        }}
                        to={`${PATHS.taskDetails}/${dataItem.requestId}`}
                      >
                        {dataItem.status === "Draft"
                          ? "View Draft"
                          : dataItem.taskNo}
                      </Link>
                    </td>
                  }
                />
              );
            }}
          />
          <GridColumn
            title="Vault Access Required"
            field="vaultAccessRequired"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessRequired ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Vault Access Added"
            field="vaultAccessAdded"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessAdded ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Assignment Group"
            field="assignmentGroup"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
          <GridColumn title="Route No" field="routeNo" width="170px" />
          <GridColumn
            title="Assigned To"
            field="assigneeId"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
          <GridColumn
            title="Secondary Assignee"
            field="secondaryAssigneeId"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
          <GridColumn title="State" field="status" width="150px" />
          <GridColumn
            title="Resolution Code"
            field="resolutionCode"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
          <GridColumn
            title="Resolution Details"
            field="resolutionDetails"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
          <GridColumn
            title="Description"
            field="remarks"
            width={userSettingsRes?.data.wrapColumnText ? "400px" : "300px"}
            cell={GridDataCopyCell}
          />
          <GridColumn
            title="Reason"
            field="reasons"
            width={userSettingsRes?.data.wrapColumnText ? "170px" : "300px"}
          />
        </Grid>
      </div>
    );
  }
  const recursiveSorting = (data, groupIndex) => {
    const _sortedData = data;
    _sortedData.forEach((elm) => {
      const isFieldExpanded = expandedGroups[elm.field];
      if (isFieldExpanded) {
        const _currentItemIndex = isFieldExpanded.findIndex(
          (item) => item === elm.value
        );
        if (_currentItemIndex !== -1) {
          elm.expanded = true;
        } else {
          elm.expanded = false;
        }
      } else {
        elm.expanded = false;
      }
    });
    const _currentGroup = dataState.group[groupIndex];
    const currentGroupIndex = data.findIndex(
      (elm) =>
        elm.field === _currentGroup.field && elm.value === _currentGroup.value
    );
    if (currentGroupIndex !== -1) {
      const currentGroup = _sortedData.splice(currentGroupIndex, 1);
      _sortedData.unshift(currentGroup[0]);
    }
    if (dataState.group.length > groupIndex + 1) {
      _sortedData.forEach((item) => {
        if (item?.items?.length > 0) {
          item.items = recursiveSorting(item.items, groupIndex + 1);
        }
      });
    }
    return _sortedData;
  };

  const groupedData = useMemo(() => {
    const processedData = process(
      tickets.map((elm) => ({
        ...elm,
        [SELECTED_FIELD]: selectedState[idGetter(elm)],
      })) || [],
      {
        ...dataState,
      }
    );

    return processedData;
  }, [tickets, dataState, selectedState]);

  const sortedData = useMemo(() => {
    const _sortedData = groupedData;
    const dataGroups = dataState.group;
    if (dataGroups.length > 0) {
      _sortedData.data = recursiveSorting(groupedData.data, 0);
    }
    return [..._sortedData.data];
  }, [groupedData, expandedGroups]);

  const columnsToRender = useMemo(() => {
    if (userColumns.length === 0) {
      return availableColumnsRes?.data?.columns || [];
    }
    return userColumns;
  }, [availableColumnsRes, userColumns]);

  const caseNoColumn = (items) => {
    const dataItem = items.dataItem;

    return (
      <GridDataCopyCell
        dataItem={items.dataItem}
        field={items.field}
        customCell={
          <td title={dataItem.caseNo}>
            <Link
              onClick={() => {
                setStatus("allServiceAndNonService");
              }}
              to={getTicketDetailsPage(dataItem)}
            >
              {dataItem.status === "Draft" ? "View Draft" : dataItem.caseNo}
            </Link>
          </td>
        }
      />
    );
  };

  const inputCell = (props) => {
    return <Input value={props.dataItem.name} />;
  };

  function NormalCell(props) {
    const { dataItem, field, ...otherProps } = props;
    const navigationAttributes = useTableKeyboardNavigation(props.id);
    const _value = dataItem[field];
    const cell = (
      <td
        {...otherProps}
        {...navigationAttributes}
        {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
        aria-selected="false"
        title={_value}
      >
        <span>
          <div
            className={`flex items-center  w-full${userSettingsRes?.data.compactRows ? " h-[50px]" : "h-full"}`}
          >
            <p
              className={`inline  w-full ${userSettingsRes?.data.wrapColumnText ? "text-wrap" : "overflow-hidden text-ellipsis text-nowrap"}${
                middleAlignColumns.includes(props.field) ||
                props.field.includes("time") ||
                props.field.includes("at")
                  ? "text-center"
                  : "text-left"
              }`}
            >
              {_value}
            </p>
          </div>
        </span>
      </td>
    );
    if (field === "resolutionDetails" || field === "remarks") {
      return (
        <GridDataCopyCell dataItem={dataItem} field={field} customCell={cell} />
      );
    }
    return cell;
  }

  const middleAlignColumns = ["status"];

  const getCurrentColumnCell = (elm) => {
    if (elm.columnId === "caseNo") {
      return caseNoColumn;
    } else if (
      !elm.columnId.includes("time") &&
      ticketsConfig?.data.filters.find(
        (item) => item.field === getField(elm.columnId)
      )
    ) {
      return ColumnActionsCell;
    }
    return NormalCell;
  };
  const getGridColumns = useMemo(() => {
    const columns = [];

    // Only add "Update" column if not a CSM Agent
    if (!isCSMAgent) {
      columns.push({
        headerCell: () => (
          <span className="k-cell-inner" style={{ height: "100%" }}>
            <span className="k-link">
              <span
                title="Update"
                className={`flex items-center font-medium k-column-title ${
                  userSettingsRes?.data.compactRows ? " h-[50px]" : ""
                }`}
              >
                <p
                  className={`inline w-full ${
                    userSettingsRes?.data.wrapColumnText
                      ? " text-wrap"
                      : " overflow-hidden text-ellipsis text-nowrap"
                  }`}
                >
                  Update
                </p>
              </span>
            </span>
          </span>
        ),
        cell: updateCell,
        width: "100px",
        filterable: false,
      });
    }

    // Add rest of the dynamic columns
    columnsToRender.forEach((elm) => {
      if (!elm.columnId) return;

      const _currentColumns = {
        headerCell: () => (
          <span className="k-cell-inner" style={{ height: "100%" }}>
            <span className="k-link">
              <span
                title={elm.label}
                className={`flex items-center font-medium k-column-title ${
                  userSettingsRes?.data.compactRows ? " h-[50px]" : ""
                }`}
              >
                <p
                  className={`inline w-full ${
                    userSettingsRes?.data.wrapColumnText
                      ? " text-wrap"
                      : " overflow-hidden text-ellipsis text-nowrap"
                  } ${
                    middleAlignColumns.includes(elm.columnId)
                      ? "text-center"
                      : "text-left"
                  }`}
                >
                  {elm.label}
                </p>
              </span>
            </span>
          </span>
        ),
        field: elm.columnId,
        className:
          middleAlignColumns.includes(elm.columnId) ||
          elm.columnId.includes("time") ||
          elm.columnId.includes("at")
            ? "text-center"
            : "text-left",
        headerClassName:
          middleAlignColumns.includes(elm.columnId) ||
          elm.columnId.includes("time") ||
          elm.columnId.includes("at")
            ? "text-center"
            : "text-left",
        width: elm.columnId === "caseNo" ? "170px" : "120px",
        cell: getCurrentColumnCell(elm),
      };

      columns.push(_currentColumns);
    });

    return columns;
  }, [ticketsList, columnsToRender, isCSMAgent]);

  const exportedColumnsTitle = {
    caseNo: "TG Reference Number",
    customerTicketNo: "Bank Reference/Address",
    customer: "Account",
  };
  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
    },
    [selectedState]
  );
  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    if (checked) {
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
    }
    setSelectedState(newSelectedState);
  }, []);

  function GroupHeaderCell(props) {
    return (
      props.tdProps && (
        <td {...props.tdProps}>
          {props.children ? (
            <p className="k-reset">
              {props.children.props.children[0]}
              {props.dataItem[props.field]}({props.dataItem.items.length})
            </p>
          ) : null}
        </td>
      )
    );
  }
  return (
    <div className="box-border">
      {gettingTickets ||
      gettingUserSettings ||
      gettingUserColumns ||
      gettingTicketsConfig ||
      gettingAvailableColumns ? (
        <Loader />
      ) : (
        <></>
      )}
      <BreadCrumb
        className="mx-4"
        items={[{ text: "Dashboard", to: "/" }, { text: "All Tickets" }]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            {/* <FilterBarV2
              exportExcel
              exportingExcel={gettingAllTickets}
              onRefresh={onRefresh}
              onExcelExport={() => {
                getAllTickets({
                  ...localFilters,
                });
              }}
            /> */}
            <DynamicFiltering
              setFilters={(payload) => {
                setFilters(payload);
              }}
              onExcelExport={() => {
                getAllTickets({ ...filters, pageNumber: 0, pageRowCount: 0 });
              }}
              onRefresh={() => {
                setReload(!reload);
              }}
              exportExcel
              exportingExcel={gettingAllTickets}
            />
          </CardDescription>
          <div className="grid-wrapper">
            <Grid
              data={sortedData}
              {...dataState}
              onDataStateChange={(e) => {
                e.dataState.skip = 0;
                setDataState(e.dataState);
              }}
              filterable
              groupable
              autoProcessData
              sortable
              pageable
              navigatable
              scrollable="scrollable"
              className={`list-tables-v1
                ${userSettingsRes?.data.wrapColumnText ? "" : "no-wrap-grid"} ${userSettingsRes?.data.compactRows ? " grid-compact-rows" : ""}`}
              width={userSettingsRes?.data.wrapColumnText ? "100%" : undefined}
              style={{ overflowX: "auto" }}
              total={totalRecords}
              pageSize={pageSize}
              skip={(currentPage - 1) * pageSize}
              dataItemKey={DATA_ITEM_KEY}
              selectedField={SELECTED_FIELD}
              onPageChange={onPageChange}
              selectable={{
                enabled: true,
                drag: true,
                cell: false,
                mode: "multiple",
              }}
              onSelectionChange={onSelectionChange}
              onHeaderSelectionChange={onHeaderSelectionChange}
              expandField="expanded"
              onExpandChange={onExpandChange}
              detail={DetailComponent}
              ref={(e) => {
                fixKendoGridContent(e);
              }}
              cells={{
                group: {
                  groupHeader: GroupHeaderCell,
                },
              }}
            >
              {getGridColumns.map((elm, index) => (
                <GridColumn key={`${elm.title}${index}`} {...elm} />
              ))}
            </Grid>
          </div>
          <ExcelExport
            data={
              allTicketsData?.data.data.map((elm) => ({
                ...elm,
                region: elm.servicePointRegion || elm.region,
              })) || []
            }
            fileName="All_Tickets.xlsx"
            ref={_exporter}
          >
            {columnsToRender.map((elm, index) => (
              <GridColumn
                key={`${elm.columnId}${index}`}
                title={exportedColumnsTitle[elm.columnId] || elm.label}
                field={elm.columnId}
              />
            ))}
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
